import { showModal } from 'src/old/actions';
import { MODAL_TYPES } from 'src/shared/components/Modals';
import { useDispatch } from 'react-redux';
import { type CustomModalProp } from 'src/modules/SaldoView/types';
import { UpdateAlertModal, type UpdateAlertModalProp } from './UpdateAlertModal';
import {
  RepaymentSummaryWireRequestModal,
  type RepaymentSummaryWireRequestModalProp
} from './RepaymentSummaryWireRequestModal';
import type { SelfFundedAccount } from 'src/shared/types/company';
import { ManualInformationModal } from './ManualInformationModal';
import { AutomaticInformationModal } from './AutomaticInformatinoModal';

export const useCompanySelectorBar = () => {
  const dispatch = useDispatch();

  const handleOpenModal = (companyId: string, account: SelfFundedAccount | undefined) => () => {
    if (!account) {
      return;
    }
    showModal(
      {
        withoutCloseIcon: true,
        CustomComponent: ({ closeModal }: CustomModalProp) => (
          <ManualInformationModal closeModal={closeModal} selectedCompanyId={companyId} account={account} />
        ),
        size: 'xs'
      },
      MODAL_TYPES.CUSTOM
    )(dispatch);
  };

  return handleOpenModal;
};

export const useAutomaticInformationModal = () => {
  const dispatch = useDispatch();

  const handleOpenModal = (companyId: string) => () => {
    showModal(
      {
        withoutCloseIcon: true,
        CustomComponent: ({ closeModal }: CustomModalProp) => (
          <AutomaticInformationModal closeModal={closeModal} selectedCompanyId={companyId} />
        ),
        size: 'xs'
      },
      MODAL_TYPES.CUSTOM
    )(dispatch);
  };

  return handleOpenModal;
};

export const useUpdateAlertModal = () => {
  const dispatch = useDispatch();

  const handleOpenModal = (companyId: string, account: SelfFundedAccount | undefined) => () => {
    if (!account) {
      return;
    }
    showModal(
      {
        withoutCloseIcon: true,
        CustomComponent: ({ closeModal }: UpdateAlertModalProp) => (
          <UpdateAlertModal closeModal={closeModal} selectedCompanyId={companyId} account={account} />
        ),
        size: 'xs'
      },
      MODAL_TYPES.CUSTOM
    )(dispatch);
  };

  return handleOpenModal;
};

export const useGenerateInvoiceModal = () => {
  const dispatch = useDispatch();

  const handleOpenModal = (companyId: string) => () => {
    showModal(
      {
        withoutCloseIcon: true,
        CustomComponent: ({ closeModal }: RepaymentSummaryWireRequestModalProp) => (
          <RepaymentSummaryWireRequestModal closeModal={closeModal} selectedCompanyId={companyId} />
        ),
        size: 'xs'
      },
      MODAL_TYPES.CUSTOM
    )(dispatch);
  };

  return handleOpenModal;
};
